"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STOREFRONT_THEME_PRESETS = void 0;
/**
 * Curated storefront theme presets (SP5c) — modern, harmonious palettes with
 * matching typography + shape. Each is a complete `ThemeSettings` snapshot.
 */
exports.STOREFRONT_THEME_PRESETS = [
    {
        id: 'aurora-dark',
        label: 'Aurora',
        description: 'Deep charcoal with an electric violet–cyan glow. Sleek and premium.',
        preview: { bg: '#0b0f19', primary: '#8b5cf6', accent: '#22d3ee' },
        settings: {
            backgroundColor: '#0b0f19', primaryColor: '#8b5cf6', primaryColorDark: '#6d28d9',
            accentColor: '#22d3ee', inkColor: '#e5e7eb',
            displayFont: 'Poppins', bodyFont: 'Inter',
            headingWeight: 'bold', fontScale: 'normal', buttonRadius: 'rounded', buttonStyle: 'solid',
            cornerRadius: 'soft', density: 'cozy', containerWidth: 'wide',
        },
    },
    {
        id: 'linen',
        label: 'Linen',
        description: 'Warm off-white, sage green, elegant serif headings. Calm & natural.',
        preview: { bg: '#f7f4ee', primary: '#3f5f49', accent: '#c08a4b' },
        settings: {
            backgroundColor: '#f7f4ee', primaryColor: '#3f5f49', primaryColorDark: '#2c4433',
            accentColor: '#c08a4b', inkColor: '#2b2b28',
            displayFont: 'Playfair Display', bodyFont: 'Inter',
            headingWeight: 'semibold', fontScale: 'normal', buttonRadius: 'pill', buttonStyle: 'solid',
            cornerRadius: 'round', density: 'cozy', containerWidth: 'standard',
        },
    },
    {
        id: 'noir',
        label: 'Noir',
        description: 'Crisp white, pure black, generous spacing. Editorial & minimal.',
        preview: { bg: '#ffffff', primary: '#111111', accent: '#8a8a8a' },
        settings: {
            backgroundColor: '#ffffff', primaryColor: '#111111', primaryColorDark: '#000000',
            accentColor: '#8a8a8a', inkColor: '#1a1a1a',
            displayFont: 'Montserrat', bodyFont: 'Inter',
            headingWeight: 'medium', fontScale: 'spacious', buttonRadius: 'sharp', buttonStyle: 'outline',
            cornerRadius: 'sharp', density: 'spacious', containerWidth: 'standard',
        },
    },
    {
        id: 'citrus',
        label: 'Citrus',
        description: 'Sunny cream, tangerine, and cobalt. Vibrant, friendly retail.',
        preview: { bg: '#fffaf3', primary: '#ea580c', accent: '#2563eb' },
        settings: {
            backgroundColor: '#fffaf3', primaryColor: '#ea580c', primaryColorDark: '#c2410c',
            accentColor: '#2563eb', inkColor: '#2a2a2a',
            displayFont: 'Poppins', bodyFont: 'Inter',
            headingWeight: 'bold', fontScale: 'spacious', buttonRadius: 'pill', buttonStyle: 'solid',
            cornerRadius: 'round', density: 'spacious', containerWidth: 'wide',
        },
    },
    {
        id: 'harbor',
        label: 'Harbor',
        description: 'Cool slate blue and teal on soft mist. Trustworthy & modern.',
        preview: { bg: '#f2f6f9', primary: '#0f4c81', accent: '#14b8a6' },
        settings: {
            backgroundColor: '#f2f6f9', primaryColor: '#0f4c81', primaryColorDark: '#0a3a63',
            accentColor: '#14b8a6', inkColor: '#20303c',
            displayFont: 'Montserrat', bodyFont: 'Inter',
            headingWeight: 'semibold', fontScale: 'normal', buttonRadius: 'rounded', buttonStyle: 'solid',
            cornerRadius: 'soft', density: 'cozy', containerWidth: 'standard',
        },
    },
    {
        id: 'orchid',
        label: 'Orchid',
        description: 'Plum and rose on blush. Bold, feminine, boutique feel.',
        preview: { bg: '#fdf5f8', primary: '#9d174d', accent: '#db2777' },
        settings: {
            backgroundColor: '#fdf5f8', primaryColor: '#9d174d', primaryColorDark: '#831843',
            accentColor: '#db2777', inkColor: '#3b2430',
            displayFont: 'Playfair Display', bodyFont: 'Inter',
            headingWeight: 'semibold', fontScale: 'normal', buttonRadius: 'pill', buttonStyle: 'solid',
            cornerRadius: 'round', density: 'cozy', containerWidth: 'standard',
        },
    },
];
//# sourceMappingURL=storefront-theme-presets.js.map